import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

export default () => {
	let lastInnerWidth;
	domContentLoaded(() => {
		const { body } = document;
		const navTriggers = document.querySelectorAll('.js_menu_trigger, .js_menu_cover');
		const navContents = document.querySelector('.js_menu');
		let sc;

		// メニュー開閉処理
		navTriggers.forEach((navTrigger) => {
			navTrigger.addEventListener('click', () => {
				lastInnerWidth = window.innerWidth;
				const flag = navContents.classList.contains('is_opened');
				if (flag) {
					closeMenu();
				} else {
					sc = Math.trunc(window.pageYOffset);
					body.style.top = `${sc * -1}px`;
					body.classList.add('is_locked');
					navContents.classList.remove('is_closed');
					navContents.classList.add('is_opened');
					navTriggers.forEach((trigger) => {
						trigger.classList.remove('is_closed');
						trigger.classList.add('is_opened');
					});
				}
			});
		});

		// メニュー内のリンクをクリックしたら閉じる
		const menuLinks = document.querySelectorAll('.bl_sitemap__menu .js_menu_anchorlink, .bl_menuItem_link, .un_homeMv_ctaBtnContact_item');
		menuLinks.forEach((menuLink) => {
			menuLink.addEventListener('click', (e) => {
				const targetUrl = e.target.href?.split('#');
				if (targetUrl && targetUrl[0] === location.href.split('#')[0]) {
					window.location.href = `./#${targetUrl[1]}`;
				}
				closeMenu();
			});
		});

		// ウィンドウサイズ変更時にメニューを閉じる
		window.addEventListener(
			'resize',
			throttle(200, () => {
				if (lastInnerWidth !== window.innerWidth && window.innerWidth >= 1024 && body.classList.contains('is_locked')) {
					closeMenu();
				}
			}),
			false
		);

		// メニューを閉じる関数
		function closeMenu() {
			body.classList.remove('is_locked');
			window.scrollTo(0, sc);
			body.style.top = '';
			navContents.classList.remove('is_opened');
			navContents.classList.add('is_closed');
			navTriggers.forEach((trigger) => {
				trigger.classList.remove('is_opened');
				trigger.classList.add('is_closed');
			});
		}
	});
};
